import Vue from 'vue'
import Vuex from 'vuex'
import * as legacyStore from '@/store'

Vue.use(Vuex)

const stateFactory = typeof legacyStore.state === 'function' ? legacyStore.state : () => ({})

export default new Vuex.Store({
  state: stateFactory(),
  mutations: legacyStore.mutations || {},
  getters: legacyStore.getters || {},
  actions: legacyStore.actions || {}
})
